import { Box, Flex, useDisclosure } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import { NoticeMessageFooter } from '../components/organisms/NoticeMessageList/NoticeMessageFooter';
import { NoticeMessageListBody } from '../components/organisms/NoticeMessageList/NoticeMessageListBody';
import { NoticeMessageListHeader } from '../components/organisms/NoticeMessageList/NoticeMessageListHeader';
import { StatusModalWindow } from '../components/organisms/NoticeMessageList/StatusModalWindow';
import {
  DeleteNoticeMessageListApi,
  GetNoticeMessageListApi
} from '../apis/NoticeMessageList.api';
import { ConfirmationDialog } from '../components/organisms/ConfirmationDialog';

export const DispMessageType = {
  Message: 1,
  Obc: 2,
  Tram: 3
};

export interface MessageSignagesDataType {
  popup_flg: boolean;
  signageDatas: Array<{ signage_id: number; signage_name: string }>;
}
export interface MessageTrainsDataType {
  delivered: boolean;
  train_no: number;
  work_status: number;
  line_name: string;
  staff_no: number;
  staff_name: string;
}

export interface MessageLocationDataType {
  message_en: string;
  link_url: string;
  popup_flg: boolean;
}

export interface NoticeMessageType {
  id: number;
  alert_level: number;
  category_id: number;
  category_name: string;
  message: string;
  term_from: Date;
  term_to: Date;
  type: number;
  messageSignagesData: MessageSignagesDataType | null;
  messageTrainsData: Array<MessageTrainsDataType> | null;
  messageLocationData: MessageLocationDataType | null;
}

const LevelEnum = {
  None: 0,
  WellKnown: 1,
  Caution: 2,
  Warning: 3,
  Emergency: 4
};

const GetAlertName = (level: number) => {
  switch (level) {
    case LevelEnum.WellKnown:
      return '周知';
    case LevelEnum.Caution:
      return '注意';
    case LevelEnum.Warning:
      return '警告';
    case LevelEnum.Emergency:
      return '緊急';
    default:
      return '---';
  }
};

const pageDispMax = 14;
const pageMax = 6;

export const NoticeMessageList = () => {
  const [messageListData, setMessageListData] =
    useState<Array<NoticeMessageType>>();
  const [chooseRow, setChooseRow] = useState<number>();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [pageNow, setPageNow] = useState<number>(1);

  const GetPageCount = (): number => {
    if (messageListData !== undefined) {
      const divisionCount = Math.floor(messageListData.length / pageDispMax);
      const remCount = messageListData.length % pageDispMax === 0 ? 0 : 1;
      return divisionCount + remCount;
    }
    return 1;
  };
  const {
    isOpen: isOpenConfirm,
    onOpen: onConfirme,
    onClose: onCloseConfirm
  } = useDisclosure();

  const GetApi = async () => {
    const response = await GetNoticeMessageListApi();

    if (response.success && response.data !== null) {
      setMessageListData(response.data);
    }
  };

  const DeleteApi = async () => {
    if (chooseRow !== undefined && messageListData !== undefined) {
      const response = await DeleteNoticeMessageListApi(
        messageListData[chooseRow].id
      );
      if (response.success && response.data !== null) {
        setMessageListData(response.data);
      }
    }
  };

  useEffect(() => {
    GetApi();
  }, []);

  return (
    <Flex direction='column' h='100vh'>
      <NoticeMessageListHeader />
      <Box
        position='relative'
        h='100%'
        display='grid'
        gridTemplateRows='2fr 0.15fr'
      >
        <NoticeMessageListBody
          onOpen={onOpen}
          onConfirm={onConfirme}
          setChooseRow={setChooseRow}
          GetAlertName={GetAlertName}
          MessageData={messageListData}
          PageDispMax={pageDispMax}
          PageDispNow={pageNow}
        />
        <NoticeMessageFooter
          GetPageCount={GetPageCount}
          pageMax={pageMax}
          pageNow={pageNow}
          setPageNow={setPageNow}
        />
      </Box>
      {isOpen && chooseRow !== undefined && (
        <StatusModalWindow
          isOpen={isOpen}
          onClose={onClose}
          MessageData={
            messageListData !== undefined
              ? messageListData[chooseRow]
              : undefined
          }
        />
      )}
      {isOpenConfirm && (
        <ConfirmationDialog
          isOpen={isOpenConfirm}
          onClose={onCloseConfirm}
          dispMessage={'本当に削除しますか？'}
          DeleteApi={DeleteApi}
        />
      )}
    </Flex>
  );
};
